import React from 'react';
import { SvgIcon } from '@mui/material';

// Centered 2x3 dot grid with larger dots
export const DragIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <circle cx="9" cy="7" r="2" fill="currentColor" />
            <circle cx="15" cy="7" r="2" fill="currentColor" />
            <circle cx="9" cy="12" r="2" fill="currentColor" />
            <circle cx="15" cy="12" r="2" fill="currentColor" />
            <circle cx="9" cy="17" r="2" fill="currentColor" />
            <circle cx="15" cy="17" r="2" fill="currentColor" />
        </SvgIcon>
    );
};
